import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { toCamelCase } from "../../hooks/toCameCase.tsx";
import { RootState } from "../../store/index.ts";

import CustomCheckboxField from "../formik/CustomCheckboxField.tsx";
import { formatDate } from "../../utils/index.ts";
import { IPendingUnsubscribe } from "../../interfaces/others/IPendingUnsubscribe";
import { CheckUnsubscribeRequestSchema } from "../../validation/schemas/CheckUnsubscribeRequestSchema.ts";
import { CheckUnsubscribeRequestInitial } from "../../interfaces/formik/ICheckUnsubscribeRequest.ts";
import CustomInput from "../formik/CustomInput.tsx";
import { setFetch, setLoading } from "../../store/slices/colaboradoresSlice.ts";
import {
  authorizeOperation,
  rejectOperation,
} from "../../services/unsubscribeRequest.service.ts";
import { notification } from "../../utils/Notifications.tsx";

const PendingUnsubscribe: React.FC<IPendingUnsubscribe> = ({
  partner,
  pendingUnsubscribe,
  closeFn,
}) => {
  const dispatch = useDispatch();
  const { fetch } = useSelector((state: RootState) => state.colaboradores);
  const { user } = useSelector((state: RootState) => state.auth);

  const formik = useFormik({
    validationSchema: CheckUnsubscribeRequestSchema,
    initialValues: CheckUnsubscribeRequestInitial,
    onSubmit: async (values) => {
      const { status, reasonForRejection } = values;
      dispatch(setLoading(true));
      try {
        if (status) {
          // Aprobar
          const response = await authorizeOperation(pendingUnsubscribe.id);
          notification("", "Baja aprobada", "success");
        } else {
          // Rechazar
          const response = await rejectOperation(pendingUnsubscribe.id, {
            reasonForRejection,
          });
          notification("", "Solicitud de baja rechazada", "info");
        }
      } catch (error) {
        notification("", "Ah ocurrido un error, intentalo mas tarde", "danger");
      } finally {
        closeFn();
        dispatch(setFetch(!fetch));
        dispatch(setLoading(false));
      }
    },
  });

  const handleClose = () => {
    dispatch(setFetch(!fetch));
    closeFn();
  };

  return (
    <React.Fragment>
      <div className="alert alert-warning" role="alert">
        <h5 className="card-title text-muted">
          <i className="fa-solid fa-triangle-exclamation"></i>&#160;
          {toCamelCase(partner.person.firstName)} tiene pendiente una solicitud de
          baja{" "}
        </h5>
      </div>

      <div className="card border-0">
        <ul className="list-group list-group-flush">
          <li
            className="list-group-item"
            style={{ display: "flex", flexDirection: "row" }}
          >
            <p style={{ fontWeight: "bold", marginBottom: "0px" }}>
              Razón de la baja:&#160;
            </p>
            {pendingUnsubscribe.reasonUnsubscribe}
          </li>
          {pendingUnsubscribe.temporalUnsubscribe && (
            <li
              className="list-group-item"
              style={{ display: "flex", flexDirection: "row" }}
            >
              <p style={{ fontWeight: "bold", marginBottom: "0px" }}>
                Baja programada:&#160;
              </p>
              {pendingUnsubscribe.banDate
                ? formatDate(pendingUnsubscribe.banDate)
                : "No especificada"}
            </li>
          )}
          <li
            className="list-group-item"
            style={{ display: "flex", flexDirection: "row" }}
          >
            <p style={{ fontWeight: "bold", marginBottom: "0px" }}>
              {" "}
              Usuario que solicitó:&#160;
            </p>
            {pendingUnsubscribe.requesterUser.name}{" "}
            {pendingUnsubscribe.requesterUser.lastName}{" "}
            {pendingUnsubscribe.requesterUser.secondLastName}
          </li>
          <li
            className="list-group-item"
            style={{ display: "flex", flexDirection: "row" }}
          >
            <p style={{ fontWeight: "bold", marginBottom: "0px" }}>
              {" "}
              Fecha de solicitud:&#160;
            </p>
            {formatDate(pendingUnsubscribe.requestDate)}
          </li>
        </ul>
      </div>
      {["Administrador", "Administrador-"].includes(user?.rol) && (
        <React.Fragment>
          <div className="border-top " style={{ margin: 0 }}></div>
          <ul className="list-group list-group-flush">
            <li className="list-group-item">
              <CustomCheckboxField
                formik={formik}
                field="status"
                label="Aprobar baja"
                mdLabel={4}
              />

              {!formik.values.status && (
                <CustomInput
                  formik={formik}
                  field="reasonForRejection"
                  label="Motivo de rechazo"
                  placeholder="Motivo de rechazo"
                  sm={9}
                  smLabel={3}
                />
              )}
            </li>
          </ul>
        </React.Fragment>
      )}

      <div className="d-flex justify-content-end">
        <button className="btn btn-secondary me-2" onClick={() => handleClose()}>
          Cerrar
        </button>
        {["Administrador", "Administrador-"].includes(user?.rol) && (
          <button
            className="btn btn-azul me-2"
            onClick={() => formik.handleSubmit()}
          >
            Enviar
          </button>
        )}
      </div>
    </React.Fragment>
  );
};

export default PendingUnsubscribe;

